// extracted by mini-css-extract-plugin
export default {"input":"input-fc5d6707"};